/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/* ==========================================
   Add to cart: product flies into cart + wiggle + speech bubble
   ========================================== */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let flying = false;

  // ---- Speech bubble sayings (edit these freely) ----
  const sayings = [
    'love that!',
    'so cute',
    'good choice',
    'obsessed',
    '💕💕',
    'love this',
    'great taste!',
    'yesss',
    'cute pick!',
    'in the bag ✨'
  ];
  const bubbleHold = 1400; // how long the bubble stays up, in ms

  let lastSaying = -1;
  let bubble = null;
  let bubbleTimer = null;

  // Returns the first matching element that's actually visible on screen
  function getVisible(selector) {
    return Array.from(document.querySelectorAll(selector)).find(function (el) {
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  // The landing spot: your custom cart image in the header
  function getCartTarget() {
    return (
      getVisible('[data-cart-drawer-toggle] .cart-icon-custom') ||
      getVisible('[data-cart-drawer-toggle]')
    );
  }

  // Centre point of the cart, or the top-right corner if the header has scrolled away
  function getAnchor(target) {
    const r = target.getBoundingClientRect();
    if (r.bottom > 0) {
      return { x: r.left + r.width / 2, y: r.top + r.height / 2, bottom: r.bottom };
    }
    return { x: window.innerWidth - 40, y: 30, bottom: 44 };
  }

  // The product image currently showing in the gallery
  function getProductImage(button) {
    const scope = button.closest('.shopify-section') || document;
    return (
      scope.querySelector('[data-product-single-media-wrapper].is-selected img') ||
      scope.querySelector('[data-product-single-media-wrapper] img') ||
      scope.querySelector('.product-gallery__media img')
    );
  }

  // Random saying, never the same one twice in a row
  function pickSaying() {
    let i;
    do {
      i = Math.floor(Math.random() * sayings.length);
    } while (sayings.length > 1 && i === lastSaying);
    lastSaying = i;
    return sayings[i];
  }

  function showBubble(target) {
    if (!target) return;

    // Build the bubble once, then reuse it
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'atc-bubble';
      bubble.setAttribute('aria-hidden', 'true');
      bubble.innerHTML =
        '<div class="atc-bubble__body"></div>' +
        '<span class="atc-bubble__tail"></span>';
      document.body.appendChild(bubble);
    }

    // Reset if one is already showing (spam clicks replace, not stack)
    clearTimeout(bubbleTimer);
    bubble.classList.remove('is-visible');
    bubble.querySelector('.atc-bubble__body').textContent = pickSaying();

    // Position just below the cart, kept on screen
    const a = getAnchor(target);
    const w = bubble.offsetWidth;
    const left = Math.max(10, Math.min(a.x - w / 2, window.innerWidth - w - 10));
    const top = a.bottom + 14;
    const tailX = Math.max(18, Math.min(a.x - left, w - 18));

    bubble.style.left = left + 'px';
    bubble.style.top = top + 'px';
    bubble.style.setProperty('--tail-x', tailX + 'px');
    bubble.style.transformOrigin = tailX + 'px 0%';

    // Restart the pop-in animation
    void bubble.offsetWidth;
    bubble.classList.add('is-visible');

    bubbleTimer = setTimeout(function () {
      bubble.classList.remove('is-visible');
    }, bubbleHold);
  }

  function wiggle(target) {
    if (!target) return;
    target.classList.remove('cart-wiggle');
    void target.offsetWidth; // restarts the animation if it's already running
    target.classList.add('cart-wiggle');
    target.addEventListener('animationend', function () {
      target.classList.remove('cart-wiggle');
    }, { once: true });

    showBubble(target);
  }

  function fly(button) {
    if (flying) return; // stops spam clicks launching loads of copies

    const target = getCartTarget();
    const img = getProductImage(button);

    // No image, no cart icon, or reduced motion on: just wiggle + bubble
    if (reduceMotion.matches || !img || !target) {
      wiggle(target);
      return;
    }

    flying = true;

    const size = 70; // size of the flying copy in px
    const start = button.getBoundingClientRect();
    const a = getAnchor(target);

    const startX = start.left + start.width / 2;
    const startY = start.top + start.height / 2;

    const dx = a.x - startX;
    const dy = a.y - startY;
    const duration = 700;

    // Outer layer moves sideways, inner layer moves up + shrinks.
    // Different easing on each = a curved arc instead of a straight line.
    const outer = document.createElement('div');
    outer.className = 'atc-fly';
    outer.style.left = (startX - size / 2) + 'px';
    outer.style.top = (startY - size / 2) + 'px';
    outer.style.width = size + 'px';
    outer.style.height = size + 'px';

    const inner = document.createElement('img');
    inner.className = 'atc-fly__img';
    inner.src = img.currentSrc || img.src;
    inner.alt = '';

    outer.appendChild(inner);
    document.body.appendChild(outer);

    const xAnim = outer.animate(
      [
        { transform: 'translateX(0)' },
        { transform: 'translateX(' + dx + 'px)' }
      ],
      { duration: duration, easing: 'cubic-bezier(0.55, 0, 0.9, 0.6)', fill: 'forwards' }
    );

    inner.animate(
      [
        { transform: 'translateY(0) scale(1)', opacity: 1 },
        { transform: 'translateY(' + dy + 'px) scale(0.2)', opacity: 0.7 }
      ],
      { duration: duration, easing: 'cubic-bezier(0.2, 0.7, 0.4, 1)', fill: 'forwards' }
    );

    xAnim.onfinish = function () {
      outer.remove();
      flying = false;
      wiggle(getCartTarget() || target);
    };
  }

  // Runs alongside Palo Alto's own add to cart, doesn't replace it
  document.addEventListener('click', function (e) {
    const button = e.target.closest('[data-add-to-cart]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    fly(button);
  }, true);
})();